declare let MMLLYin: any;

export function detectPitch(buf: AudioBuffer) {
  let blockSize = 256;
  let yin = new MMLLYin(buf.sampleRate, blockSize);
  let data = buf.getChannelData(0);
  for (let offset = 0; offset < buf.length; offset += blockSize) {
    let window = data.subarray(offset, offset + blockSize);
    yin.next(window);
  }
  return Math.round(yin.m_midipitch);
}
